import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';


// Suppress Mapbox AbortError - harmless tile cancellation noise
// Silence the harmless "signal is aborted without reason" map errors in development
if (process.env.NODE_ENV === 'development') {
  window.addEventListener('unhandledrejection', (event) => {
    if (event.reason && (event.reason.name === 'AbortError' || event.reason.message?.includes('aborted'))) {
      event.preventDefault();
    }
  });
}

window.addEventListener('unhandledrejection', event => {
  if (event.reason && event.reason.name === 'AbortError') {
    event.preventDefault(); // Prevents the React error overlay from popping up
  }
});

 

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
